export const formatMoney = () => {
  return 'test1';
};
